import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation, Navigate, Outlet } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import Loader from "@/components/Loader";
import AccountStatus from "@/components/AccountStatus";
import DashboardLayout from "@/components/DashboardLayout";
import Login from "@/pages/Login";
import AuthCallback from "@/pages/AuthCallback";
import Dashboard from "@/pages/Dashboard";
import Batteries from "@/pages/Batteries";
import RegisterBattery from "@/pages/RegisterBattery";
import Claims from "@/pages/Claims";
import NewClaim from "@/pages/NewClaim";
import ClaimDetail from "@/pages/ClaimDetail";
import Users from "@/pages/Users";
import ServiceCenters from "@/pages/ServiceCenters";
import CustomFields from "@/pages/CustomFields";
import DataIO from "@/pages/DataIO";
import Reports from "@/pages/Reports";
import Settings from "@/pages/Settings";

function RequireAuth() {
  const { user, loading } = useAuth();
  if (loading) return <Loader label="Loading portal..." />;
  if (!user) return <Navigate to="/login" replace />;
  if (user.status === "pending" || user.status === "rejected") return <AccountStatus kind={user.status} />;
  return (
    <DashboardLayout>
      <Outlet />
    </DashboardLayout>
  );
}

function AppRouter() {
  const location = useLocation();
  // Process OAuth callback FIRST (synchronously during render) to avoid race conditions
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route element={<RequireAuth />}>
        <Route path="/" element={<Navigate to="/dashboard" replace />} />
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/batteries" element={<Batteries />} />
        <Route path="/register-battery" element={<RegisterBattery />} />
        <Route path="/claims" element={<Claims />} />
        <Route path="/claims/new" element={<NewClaim />} />
        <Route path="/claims/:id" element={<ClaimDetail />} />
        <Route path="/users" element={<Users />} />
        <Route path="/service-centers" element={<ServiceCenters />} />
        <Route path="/custom-fields" element={<CustomFields />} />
        <Route path="/data" element={<DataIO />} />
        <Route path="/reports" element={<Reports />} />
        <Route path="/settings" element={<Settings />} />
      </Route>
      <Route path="*" element={<Navigate to="/dashboard" replace />} />
    </Routes>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <AppRouter />
          <Toaster position="top-right" richColors closeButton />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
